import { render, staticRenderFns } from "./DateMeal-orderMeal.vue?vue&type=template&id=8eb36386&scoped=true&"
import script from "./DateMeal-orderMeal.vue?vue&type=script&lang=js&"
export * from "./DateMeal-orderMeal.vue?vue&type=script&lang=js&"
import style0 from "./DateMeal-orderMeal.vue?vue&type=style&index=0&id=8eb36386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb36386",
  null
  
)

export default component.exports